import config from "@/config";
import http from "@/utils/request";

export default {
	background: {
		detail: {
			url: `${config.API_URL}/config/show`,
			name: "保存配方背景图",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		save: {
			url: `${config.API_URL}/config/store`,
			name: "修改配方背景图",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
};
